// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-4ed0cb61]{position:fixed;top:180px;right:10px;width:40px;display:flex;flex-direction:column;z-index:100;border-top-right-radius:10px;border-bottom-right-radius:10px}@media (min-width:1280px){.wrap[data-v-4ed0cb61]{width:70px}}.wrap a[data-v-4ed0cb61]{background-color:#3d3d3d;border-radius:50%;transition:background .25s ease-in-out 0ms}.wrap a[data-v-4ed0cb61]:hover{background-color:#d551ad}.wrap a svg *[data-v-4ed0cb61]{fill:#fff}", ""]);
// Exports
module.exports = exports;
